import { Badge, IconButton, Menu, Typography, Chip, Divider, List, ListItem, ListItemText, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from "@mui/material";
import { Notifications, Close, CheckCircle, Cancel } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchNotificationCount } from "../../action/searchFilterAction";
import AddAlertMessage from "../alert/Alert";
import { ERROR, SUCCESS, SOMETHING_WENT_WRONG } from "../../utils/constants";
import { useStyles } from "./style";
import { fetchPendingNotifications, rejectNotification, fetchSourceData } from "./notificationService";
import { AppUtils } from "../../utils/appUtils";
import { AppMisc } from "../../misc/appMisc";

export const REGISTER_CONFIG = {
  OUTPATIENT: {
    label: "बहिरङ्ग सेवा",
    apiKey: "outPatient",
  }
};

const RegisterNotificationBell = ({ targetRegister, onAccept, onReject }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const { notificationData } = useSelector((state) => state.searchFilter);
  const { totalSize: count, objectList: notifications } = notificationData || { totalSize: 0, objectList: [] };
  const [rejectDialog, setRejectDialog] = useState({ open: false, notification: null, reason: "" });
  const isOpen = Boolean(anchorEl);

  const updateCount = () => {
    dispatch(fetchNotificationCount(targetRegister));
  };

  useEffect(() => {
    updateCount();
  }, [targetRegister, dispatch]);

  const handleAccept = async (notification) => {
    try {
      const config = REGISTER_CONFIG[notification.sourceRegister];
      if (!config) {
        AddAlertMessage({ type: ERROR, message: `Source register ${notification.sourceRegister} not supported` });
        return;
      }

      const sourceData = await fetchSourceData(config.apiKey, notification.sourceId);

      if (onAccept) {
        onAccept(notification, sourceData);
      }

      setAnchorEl(null);
    } catch (error) {
      AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
    }
  };

  const handleReject = async () => {
    try {
      await rejectNotification({
        notificationId: rejectDialog.notification.id,
        rejectionReason: rejectDialog.reason.trim(),
      });

      if (onReject) onReject(rejectDialog.notification);

      setRejectDialog({ open: false, notification: null, reason: "" });
      setAnchorEl(null);
      updateCount();
    } catch (error) {
      AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
    }
  };

  const grouped = notifications.reduce((acc, n) => {
    const reg = n.sourceRegister || "OTHER";
    (acc[reg] || (acc[reg] = [])).push(n);
    return acc;
  }, {});

  return (
    notifications?.length > 0 && (
      <>
        <IconButton color="inherit" onClick={(e) => setAnchorEl(e.currentTarget)}>
          <Badge badgeContent={count} color="error">
            <Notifications />
          </Badge>
        </IconButton>

        <Menu anchorEl={anchorEl} open={isOpen} onClose={() => setAnchorEl(null)} PaperProps={{ className: classes.menuPaper }} transformOrigin={{ horizontal: "right", vertical: "top" }} anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
          <div className={classes.header}>
            <Typography variant="subtitle1" className={classes.title}>सेवा लिन बाँकी सेवाग्राहीहरु</Typography>
            <IconButton className={classes.closeButton} onClick={() => setAnchorEl(null)}><Close fontSize="small" /></IconButton>
          </div>
          <Divider />
          {Object.entries(grouped).map(([register, notifs]) => (
            <div key={register} className={classes.groupContainer}>
              <div className={classes.groupHeader}>
                <Typography className={classes.groupTitle}>{REGISTER_CONFIG[register]?.label || register}</Typography>
                <Chip label={notifs.length} size="small" color="primary" className={classes.chip} />
              </div>
              <List dense className={classes.listContainer}>
                {notifs.map((n) => (
                  <ListItem key={n.id} className={classes.listItem} secondaryAction={
                    <div className={classes.actionButtons}>
                      <IconButton size="small" color="success" onClick={() => handleAccept(n)}>
                        <CheckCircle fontSize="small" />
                      </IconButton>
                      <IconButton size="small" color="error" onClick={() => setRejectDialog({ open: true, notification: n, reason: "" })}>
                        <Cancel fontSize="small" />
                      </IconButton>
                    </div>
                  }>
                    <ListItemText
                      primary={<Typography variant="body2" fontWeight={600}>{`${n.patientFirstName || ""} ${n.patientLastName || ""}`.trim() || ""}</Typography>}
                      secondary={
                        <div className={classes.secondaryText}>
                          <Typography variant="caption" color="text.secondary">मूल दर्ता नं: {n.muldartaaNumber || ""}({AppUtils.replaceWithNepaliDigit(n.age) + " " + AppMisc.getAgeUnitLabel(n.ageUnit)})</Typography>
                        </div>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </div>
          ))}
        </Menu>
        <Dialog open={rejectDialog.open} onClose={() => setRejectDialog({ open: false, notification: null, reason: "" })} maxWidth="sm" fullWidth>
          <DialogTitle className={classes.dialogTitle}>सेवाग्राही हटाउनुको कारण</DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <TextField fullWidth value={rejectDialog.reason} onChange={(e) => setRejectDialog({ open: true, notification: rejectDialog.notification, reason: e.target.value })} placeholder="सेवाग्राही हटाउनुको कारण" required />
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={() => setRejectDialog({ open: false, notification: null, reason: "" })} color="primary" variant="contained">Close</Button>
            <Button onClick={handleReject} color="error" variant="contained" disabled={!rejectDialog.reason.trim()}>Submit</Button>
          </DialogActions>
        </Dialog>
      </>
    )
  );
};

export default RegisterNotificationBell;
